"use client";

import { useSyncExternalStore } from "react";
import { usePathname } from "next/navigation";
import { Capacitor } from "@capacitor/core";
import LegalLinks from "@/components/LegalLinks";

const subscribe = () => () => {};
const getNativeSnapshot = () => Capacitor.isNativePlatform();
const getServerSnapshot = () => false;

// Route prefixes where the global footer is suppressed: only the bottom-nav
// tab shells (/main, /landowner), where the footer would sit permanently
// behind the fixed BottomTabs and its legal links are relocated onto the
// profile pages instead (T-182 P6). Everywhere else — including the gateway
// and the rest of /auth — the footer renders below the fold, reachable by
// scrolling (T-182 P1: the gateway root is min-h-screen so the footer never
// enters the top viewport before the hero paints).
const FOOTER_SUPPRESSED_PREFIXES = ["/main", "/landowner"];

// Match a prefix only at a path boundary — "/main" suppresses "/main" and
// "/main/…", but NOT a future sibling like "/main-marketing" or "/landowners".
const isSuppressedRoute = (pathname: string | null): boolean =>
  !!pathname &&
  FOOTER_SUPPRESSED_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"));

export default function Footer() {
  const isNative = useSyncExternalStore(subscribe, getNativeSnapshot, getServerSnapshot);
  const pathname = usePathname();

  if (isNative) return null;
  if (isSuppressedRoute(pathname)) return null;

  return (
    <footer className="w-full border-t border-gray-200 bg-white px-6 py-6 text-center text-sm text-gray-600">
      <LegalLinks />
      <p className="mt-3 text-xs text-gray-400">
        © {new Date().getFullYear()} AccessHunter. All rights reserved.
      </p>
    </footer>
  );
}
